type Markers = {
    [storeId: string]: google.maps.Marker;
};

export const getMarkersOnMap = (markers: Markers, map: google.maps.Map) =>
    Object.values(markers).filter((marker) => map?.getBounds()?.contains(marker.getPosition()));
